import React from 'react'
import ReactDOM from 'react-dom'
import "./index.global.scss"

import App from './app/App'
import Router from "react-router-dom/Router";
import getHistory from "./store/getHistory"

import 'react-dates/initialize'

ReactDOM.render(
    <Router history={getHistory()}>
        <App/>
    </Router>,
    document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js